import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __ANPR_PERSON_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface TitleStudyListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (titleStudy?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

type Key = {
  codice: string;
};

interface TitleStudy {
  key: Key;
  descrizione: string;
}

const TitleStudyListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Titolo di studio',
  id = 'titleStudy',
}: TitleStudyListComponentProps): React.ReactElement => {
  const [titleStudy] = useHttpFetch<HttpResponseList<TitleStudy>, Array<ItemVM>>(
    `${__ANPR_PERSON_API_URL__}/titolo-studio`,
    {
      onBootstrap: true,
      initialData: [],
      transformer: (response: AxiosResponse<HttpResponseList<TitleStudy>>) => {
        const { data } = response;

        return data?.payload.list.map((item) => ({
          id: item.key.codice,
          value: item.descrizione,
        })) as Array<ItemVM>;
      },
    }
  );

  const list = (titleStudy.data as Array<ItemVM>) || [];

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TitleStudyListComponent.displayName = 'Title Study List component';

const TitleStudyList = memo(TitleStudyListComponent);

export default TitleStudyList as typeof TitleStudyListComponent;
